import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const TwoAdultsIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescAdultsHungerStat">Two Adults</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <circle
        cx="67.3"
        cy="47.9"
        r="10.9"
        transform="rotate(-60.3 67.3 47.9)"
        color="gray.200"
      />
      <path
        d="M87.4 71.2c-1-4.6-3.6-9.2-9.2-9.2H73l-5 12-5.3-12h-5.8c-5.9 0-8.5 5-9.3 9.8H56s0 78.1.2 78.8c.2 3.8 3.2 6.3 7.3 6.3h8.2c4 0 7-2.5 7.3-6.3V71.2h8.5Z"
        color="gray.200"
      />
      <path
        d="m90.5 100-2.6-26.5c0-2.4-1.9-9.8-6.5-10.7l-.8 1.6L78 71l3.8 29a4.8 4.8 0 0 0 4.7 4.6c2.2 0 4-1.6 3.9-4.7Zm-46 0 2.6-26.5c0-2.4 1.8-9.8 6.5-10.7l.8 1.6 2.5 6.6-3.8 29a4.8 4.8 0 0 1-4.7 4.6c-2.3 0-4-1.6-3.9-4.7Z"
        color="gray.200"
      />
      <circle
        cx="67.3"
        cy="47.9"
        r="10.9"
        transform="rotate(-60.3 67.3 47.9)"
        className="accent"
      />
      <circle
        cx="67.3"
        cy="47.9"
        r="10.9"
        transform="rotate(-60.3 67.3 47.9)"
        className="accent"
      />
      <path
        d="M87.9 73.5c0-2.2-1.5-8.3-5.1-10.2a8 8 0 0 0-4.6-1.3H73l-5 12-5.3-12h-5.8a8.2 8.2 0 0 0-4.6 1.3c-3.6 2-5 8-5 10.2L44.6 100c-.1 3 1.6 4.6 3.9 4.7A4.8 4.8 0 0 0 53 100l3-21.6c0 19 0 71.6.2 72 .2 3.9 3.2 6.4 7.3 6.4h8.2c4 0 7-2.5 7.3-6.3V77.7l3 22.3a4.8 4.8 0 0 0 4.7 4.6c2.2 0 4-1.6 3.9-4.7L88 73.5Z"
        className="accent"
      />
      <circle
        cx="127.2"
        cy="47.9"
        r="10.9"
        transform="rotate(-34.8 127.2 47.9)"
        className="accent"
      />
      <circle
        cx="127.2"
        cy="47.9"
        r="10.9"
        transform="rotate(-34.8 127.2 47.9)"
        className="accent"
      />
      <path
        d="m154 97.5-8.8-27.7c-.5-2.3-2.3-7.8-7-7.8h-4.7l-6 10.1V72l-.1.1-.1-.1-6-10h-4.8c-4.7 0-6.5 5.5-7 7.8l-9 29c-.7 3 .6 4.8 2.8 5.4a4.8 4.8 0 0 0 5.6-3.5l6.8-19.2 2.3 4.7-12 35.3h9.8s0 28.3.2 29c.2 3.8 3.2 6.3 7.3 6.3h8c4 0 7-2.5 7.3-6.3.2-.8.2-29 .2-29h9.8L137 86.2l2.1-4.7 6.6 18a4.8 4.8 0 0 0 5.5 3.5c2.2-.6 3.6-2.4 2.9-5.5Z"
        className="accent"
      />
      <path
        d="m154 97.5-8.8-27.7c-.5-2.3-2.3-7.8-7-7.8h-4.7l-6 10.1V72l-.1.1-.1-.1-6-10h-4.8c-4.7 0-6.5 5.5-7 7.8l-9 29c-.7 3 .6 4.8 2.8 5.4a4.8 4.8 0 0 0 5.6-3.5l6.8-19.2 2.3 4.7-12 35.3h9.8s0 28.3.2 29c.2 3.8 3.2 6.3 7.3 6.3h8c4 0 7-2.5 7.3-6.3.2-.8.2-29 .2-29h9.8L137 86.2l2.1-4.7 6.6 18a4.8 4.8 0 0 0 5.5 3.5c2.2-.6 3.6-2.4 2.9-5.5Z"
        className="accent"
      />
    </Icon>
  );
};

export default TwoAdultsIcon;
